import { useSelector } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { EventsState } from '../../../../../../store/types';
import LandingPanel from '../panel/landing/landing';
import Registration from '../panel/registration/registration';
import EventPanel from './event/event';
import ThemePanel from './theme/theme';
// import CommentsPanel from './comments';
// import VersionsPanel from './versions';
// import SettingsPanel from './settings/settings';
import SessionPanel from '../../../session/navigation/panel/session-panel';
import classNames from 'classnames';
import { PATHNAMES } from "../../../../admin";

const Panel: React.FC = () => {
	const {
		EventPanelReducer: {
			panelOpen
		}
	} = useSelector((state: EventsState) => state);

	return (
		<div className={classNames("panel-container", { open: panelOpen })}>
			<div className="panel-slider">
				<Switch>
					<Route path={PATHNAMES.Event.Theme}>
						<ThemePanel />
					</Route>
					<Route path={PATHNAMES.SessionBasePath}>
						<SessionPanel />
					</Route>
					<Route path={PATHNAMES.Event.Landing}>
						<LandingPanel />
					</Route>
					<Route path={PATHNAMES.Event.Registration}>
						<Registration />
					</Route>
					<Route>
						<EventPanel />
					</Route>
				</Switch>
			</div>
		</div>
	);
};

export default Panel;